if (!customElements.get('lazy-featured-collection')) {
  customElements.define('lazy-featured-collection', class LazyFeaturedCollection extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback() {
      const productList = this.querySelector('[data-product-list]');
      
      if (!productList) return;
      
      // Initially hide products with opacity
      productList.style.opacity = '0';
      productList.style.transition = 'opacity 0.3s ease-in-out';
      
      this.initIntersectionObserver(productList);
    }

    initIntersectionObserver(productList) {
      const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Show products with fade-in effect
            productList.style.opacity = '1';
            
            // Stop observing after loaded
            observer.unobserve(this);
          }
        });
      };
      
      // Create observer with rootMargin to load before section is visible
      this.observer = new IntersectionObserver(handleIntersection, {
        rootMargin: '400px 0px 400px 0px',
        threshold: 0
      });
      
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  });
}
